<div class="loading-container" *ngIf="isProgressSpinnerShown$ | async">
  <div class="loading">
    <p-progressSpinner [strokeWidth]="'4'"></p-progressSpinner>
  </div>
</div>
